import axios from "axios";
import SessionService from "../_services/session.service";
import { store } from "../_store/root-store";
import { showError } from "../_reducers/alert.reducer";
import { hide, show } from "../_reducers/loader.reducer";
import handleError from "./handler-exception";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const setupAxiosInterceptors = (dispatch: any) => {
  api.interceptors.request.use(
    (config) => {
      dispatch(show());
      const accessToken = SessionService.getAccessToken();
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  api.interceptors.response.use(
    (response) => {
      dispatch(hide());
      return response.data;
    },
    async (error) => {
      if (error.response) {
        handleError(error);
        // The request was made, but the server responded with a status code
        console.error(
          "Response Error:",
          error.response.status,
          error.response.data
        );
        const data = error.response.data;
        // Backend uses two shapes: 400 business failures put the message in
        // `error.message`; 401/403/other shapes put it in top-level `message`.
        const message = data?.error?.message ?? data?.message;
        if (message) {
          dispatch(showError(message));
        }
        dispatch(hide());
        // On 400 business failures, surface the envelope so callers can
        // inspect `isSucceed` / `error.code` instead of just seeing undefined.
        if (error.response.status === 400 && data) {
          return data;
        }
      } else if (error.request) {
        console.error("Request Error:", error.request);
        dispatch(showError(error.message));
        dispatch(hide());
      } else {
        // Dispatch your error action
        dispatch(showError(error.message));
        dispatch(hide());
      }
      // return Promise.reject(error);
    }
  );
};
setupAxiosInterceptors(store.dispatch);
export { api, setupAxiosInterceptors };
